import { Statistic } from '../components/StockTable';

// Analyst views statistics configuration organized by category
export const ANALYST_VIEWS_STATISTICS: Statistic[] = [
  // Price Targets
  { key: 'priceTargetRange', label: 'Price Target Range', type: 'financial' },
  { key: 'averagePriceTarget', label: 'Average Price Target', type: 'financial' },
  { key: 'lastClosingPrice', label: 'Last Closing Price', type: 'financial' },
  { key: 'priceTargetDifference', label: 'Potential Upside', type: 'ratio' },
  
  // Recommendations
  { key: 'averageRecommendation', label: 'Average Recommendation', type: 'financial' },
  { key: 'strongBuyCount', label: '# of Strong Buy', type: 'financial' },
  { key: 'buyCount', label: '# of Buy', type: 'financial' },
  { key: 'holdCount', label: '# of Hold', type: 'financial' },
  { key: 'sellCount', label: '# of Sell', type: 'financial' },
  { key: 'strongSellCount', label: '# of Strong Sell', type: 'financial' },
  { key: 'strongBuyPercent', label: '% Strong Buy', type: 'ratio' },
  { key: 'buyPercent', label: '% Buy', type: 'ratio' },
  { key: 'holdPercent', label: '% Hold', type: 'ratio' },
  { key: 'sellPercent', label: '% Sell', type: 'ratio' },
  { key: 'strongSellPercent', label: '% Strong Sell', type: 'ratio' },
  
  // Earnings
  { key: 'nextEarningsDate', label: 'Next Earnings Date', type: 'date' },
  { key: 'thisQuarterEpsAvg', label: 'Current Quarter EPS Average Estimate', type: 'financial' },
  { key: 'thisQuarterEpsRange', label: 'Current Quarter EPS Estimate Range', type: 'financial' },
  { key: 'nextQuarterEpsAvg', label: 'Next Quarter EPS Average Estimate', type: 'financial' },
  { key: 'nextQuarterEpsRange', label: 'Next Quarter EPS Estimate Range', type: 'financial' },
  { key: 'thisYearEpsAvg', label: 'Current Year EPS Average Estimate', type: 'financial' },
  { key: 'thisYearEpsRange', label: 'Current Year EPS Estimate Range', type: 'financial' },
  { key: 'nextYearEpsAvg', label: 'Next Year EPS Average Estimate', type: 'financial' },
  { key: 'nextYearEpsRange', label: 'Next Year EPS Estimate Range', type: 'financial' },
];

// Category headers for organizing statistics
export const ANALYST_VIEWS_CATEGORY_HEADERS = [
  { startIndex: 0, label: 'Price Targets' },
  { startIndex: 4, label: 'Recommendations' },
  { startIndex: 15, label: 'Earnings Estimates' },
];

